import React, { } from 'react';
import { Spinner as Spn } from '@chakra-ui/react'

const Spinner = () => {
  return(
    <Spn
        thickness='4px'
        speed='0.65s'
        emptyColor='gray.200'
        color='primary'
        size="xl"
    />   
  );
}

export default Spinner;
